export enum ChannelType {
  digital = 'D',
  agency = 'A'
}
